import React from "react";

class PortalMobileMenu extends React.Component {
    render() {
        return (
            <>
                <div className="mobile-menu md:hidden">
                    <div className="mobile-menu-bar">
                        <a href="/portal/home" className="flex mr-auto">
                            <img alt="UShort" className="w-6" src="/assets/midone/images/logo.png" />
                        </a>
                        <a href="#/" id="mobile-menu-toggler"> <i data-feather="bar-chart-2" className="w-8 h-8 text-white transform -rotate-90"></i> </a>
                    </div>
                    <ul className="border-t border-theme-24 py-5 hidden">
                        <li>
                            <a href="/portal/home" className="menu dashboard">
                                <div className="menu__icon"> <i data-feather="home"></i> </div>
                                <div className="menu__title"> Dashboard </div>
                            </a>
                        </li>
                        <li>
                            <a href="#/" className="menu short_url">
                                <div className="menu__icon"> <i data-feather="link"></i> </div>
                                <div className="menu__title"> Short URLs <i data-feather="chevron-down" className="menu__sub-icon"></i> </div>
                            </a>
                            <ul className="">
                                <li>
                                    <a href="/portal/url/create" className="menu">
                                        <div className="menu__icon"> <i data-feather="link"></i> </div>
                                        <div className="menu__title"> Create Short URL </div>
                                    </a>
                                </li>
                                <li>
                                    <a href="/portal/url/track" className="menu">
                                        <div className="menu__icon"> <i data-feather="activity"></i> </div>
                                        <div className="menu__title"> Track URL </div>
                                    </a>
                                </li>
                            </ul>
                        </li>
                        <li>
                            <a href="/portal/analytics" className="menu analytics">
                                <div className="menu__icon"> <i data-feather="bar-chart"></i> </div>
                                <div className="menu__title"> Analytics </div>
                            </a>
                        </li>
                    </ul>
                </div>

            </>
        );
    }
}

export default PortalMobileMenu;